/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";

export class PasswordFieldViewer extends BaseFieldViewer {
	@autobind
	_render() {
		return "";
	}
}